<template>
  <div class="page-container">
    <div class="page-card">
      <!-- 页头 -->
      <div class="page-card__header">
        <el-row>
          <el-col :span="2">
            <div style="font-size: 18px; font-weight: bold; line-height: 40px">
              展会报道
            </div>
          </el-col>
          <el-col :span="22">
            <div style="text-align: right">
              <el-button
                type="primary"
                round
                size="small"
                @click="go_to_addStationInfo"
                >添加新闻报道
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%; padding: 0 20px">
        <el-table-column prop="image" label="封面" width="150">
          <template slot-scope="scope">
            <el-image :src="imgUrl + scope.row.img"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="报道标题"> </el-table-column>
        <el-table-column prop="create_time" label="发布时间" width="200">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleClick(scope.row)"
              >详情</el-button>
            <el-button
              type="text"
              class="action-btn--danger"
              @click="deleteClick(scope.row)"
              >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "eventManage",
  data() {
    return {
      tableData: [],
      imgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news_banner/",
      // 分页相关
      // 总条目数
      aSum: 0,
      // 当前页数
      currentPage: 1,
      // 总页数
      pageCount: 1,
      // 每页显示条目数
      pagesize: 10,
    };
  },
  mounted() {
    // 获取展会报道列表
    this.getInfo();
  },
  methods: {
    // 获取展会报道列表
    getInfo() {
      let url = this.baseUrl + "/admin/news/?ordering=-create_time&type=1";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 切换分页
    handleCurrentChange(val) {
      let url = this.baseUrl + "/admin/news/?ordering=-create_time&type=1&page=" + val;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 删除展会报道
    deleteClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let id = row.id;
        let url = this.baseUrl + "/admin/news/" + id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getInfo();
        });
      });
    },

    // 查看报道详情
    handleClick(row) {
      this.$router.push({
        name: "admin_stationInfoDetail",
        query: { id: row.id },
      });
    },

    // 跳转添加新闻报道页面
    go_to_addStationInfo() {
      this.$router.push({ name: "admin_addStationInfo" });
    },
  },
  components: {
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/eventManage.vue